import React from 'react';
import { Car, Zap, Bike, Building, Calendar, Camera } from 'lucide-react';
import { shootingTypes } from '../data/mock';

const ServicesSection = () => {
  const iconMap = {
    Car,
    Zap,
    Bike,
    Building,
    Calendar,
    Camera
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="services"
      className="section-spacing-large"
      style={{ backgroundColor: 'var(--color-black)' }}
    >
      <div className="container-artworld">
        {/* Section Title */}
        <div className="text-center mb-16">
          <p className="label-text mb-4">Nos Prestations</p>
          <h2 className="section-title">Services de Shooting</h2>
          <p className="body-text max-w-3xl mx-auto mt-6">
            Des prestations sur mesure pour valoriser chaque véhicule. 
            De la supercar au quotidien, chaque machine mérite une mise en scène d'exception.
          </p>
          <div
            className="w-24 h-1 mx-auto mt-6"
            style={{
              background: 'linear-gradient(90deg, transparent, var(--color-red-accent), transparent)'
            }}
          />
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {shootingTypes.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-8"
                style={{
                  background: 'var(--color-carbon)',
                  border: '1px solid var(--color-dark-gray)',
                  transition: 'all var(--transition-normal)'
                }}
              >
                {/* Hover Effect */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{
                    background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, transparent 100%)',
                    border: '1px solid var(--color-red-accent)'
                  }}
                />

                {/* Content */}
                <div className="relative z-10">
                  <div
                    className="mb-6 inline-flex p-4 rounded-full"
                    style={{
                      background: 'rgba(220, 38, 38, 0.1)',
                      border: '1px solid var(--color-red-accent)'
                    }}
                  >
                    <IconComponent size={32} style={{ color: 'var(--color-red-accent)' }} />
                  </div>

                  <h3
                    className="subtitle mb-4"
                    style={{
                      fontSize: '1.25rem',
                      color: 'var(--color-white)',
                      letterSpacing: '0.02em'
                    }}
                  >
                    {service.title}
                  </h3>

                  <p className="body-text">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Pricing Info */}
        <div
          className="max-w-4xl mx-auto p-8 text-center"
          style={{
            background: 'var(--color-carbon)',
            border: '2px solid var(--color-red-accent)'
          }}
        >
          <h3
            className="subtitle mb-4"
            style={{ fontSize: '1.5rem', color: 'var(--color-white)' }}
          >
            Tarifs
          </h3>
          <p className="body-text mb-6">
            La <strong style={{ color: 'var(--color-white)' }}>passion automobile</strong> est la priorité.
            <br />
            Pour le moment, les shootings fonctionnent sur une{' '}
            <strong style={{ color: 'var(--color-red-accent)' }}>participation libre</strong>.
          </p>
          <button onClick={scrollToContact} className="btn-accent">
            Demander un Devis
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
